var iframes = document.getElementsByTagName('iframe'),
    resizer = function(iframe) {
      var doc = iframe.contentDocument ? iframe.contentDocument : iframe.contentWindow.document,
          body = doc.body,
          html = doc.documentElement,
          height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

      // add 30px headroom in case a horizontal scrollbar is shown
      height += 30;

      iframe.style.height = 0;
      iframe.style.height = height + "px";
      iframe.style.boxSizing = 'content-box';

      body.style.overflowY = 'hidden';
    };


for (var i = 0; i < iframes.length; i++){
    iframes[i].addEventListener('load', function(e) {
        resizer(this);
    });
    resizer(iframes[i]);
}
